import React from "react";
import "./programDates.css";

import { Row, Col, Container } from "reactstrap";

const ProgramDates = props => {
  return (
    <div>
      <section className="program-dates">
        <Container>
          <Row className="section-headline justify-content-center align-items-center">
           
              <Row>
               <Col className="program-headline" >
                <h1>Program Dates</h1>
                 </Col>
              </Row>
           
          </Row>
          {props.children}
        </Container>
      </section>
    </div>
  );
};

export default ProgramDates;
